import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeAllModals } from '../../../actions/modalActions';
import useKeyboardEvent from '../../../hooks/useKeyboardEvent';
import { ReactComponent as Close } from '../../../icons/close-button.svg';
import { A, P } from '../../base/typography';
import * as StyledModals from '../../myPost/modals/myShipmentsModals.styles';
import NewsletterForm from '../../newsletterForm';
import * as StyledNewsletter from './newsLetterModal.styles';

interface Props {}

const CompanyServicePortalModal: FC<Props> = () => {
	const { modalHeading, modalQrCodeValue, modalCallback } = useSelector(({ modalReducer }) => modalReducer);

	const dispatch = useDispatch<any>();
	useKeyboardEvent('Escape', () => closeAllModals());

	const closeModal = () => {
		dispatch(closeAllModals());
		document.body.style.overflow = 'unset';
	};
	document.body.style.overflow = 'hidden';

	return (
		<StyledNewsletter.Wrapper>
			<StyledNewsletter.Image image={modalCallback} />
			<div>
				<StyledNewsletter.FormWrapper>
					<StyledModals.Heading>
						<div>{modalHeading}</div>
						<A onClick={closeModal}>
							<Close />
						</A>
					</StyledModals.Heading>
					<P>{modalQrCodeValue}</P>
					<NewsletterForm />
				</StyledNewsletter.FormWrapper>
			</div>
		</StyledNewsletter.Wrapper>
	);
};

export default CompanyServicePortalModal;
